<template>
  <router-view />
  <CustomerDetail
    width="1200px"
    :isShowDialog="isShowDrawer"
    @close="handleDrawerClose"
    direction="rtl"
    :userId="drawerId"
  />
</template>
<script>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { ElButton, ElMessageBox } from "element-plus";
import { useRoute } from "vue-router";
import CustomerDetail from "@/components/drawer-form/index.vue";
// import Layout from "./components/layout";

export default {
  name: "App",
  components: {
    [ElButton.name]: ElButton,
    CustomerDetail,
  },
  setup() {
    const websock = ref(null);
    const lockReconnect = ref(false);
    const timeoutnum = ref(null);
    const timeoutObj = ref(null);

    const route = useRoute();
    const { state } = useStore();
    onMounted(() => {});

    onUnmounted(() => {
      websock.value.close();
    });
    const userInfo = computed(() => state.userInfo);
    watch(
      () => state.userInfo,
      () => {
        if (route.path != "/login") {
          initWebSocket();
        }
      }
    );

    const initWebSocket = () => {
      //初始化weosocket
      let ip = process.env.VUE_APP_IP;
      let port = process.env.VUE_APP_PORT;
      const wsuri = `wss://${ip}:${port}/connect/web/` + userInfo.value.id;
      websock.value = new WebSocket(wsuri);
      websock.value.onmessage = websocketonmessage;
      websock.value.onopen = websocketonopen;
      websock.value.onerror = websocketonerror;
      websock.value.onclose = websocketclose;
    };
    const reconnect = () => {
      if (lockReconnect.value) {
        return;
      }
      console.log("1231445");
      lockReconnect.value = true;
      timeoutnum.value && clearTimeout(timeoutnum.value);
      timeoutnum.value = setTimeout(function () {
        //新连接
        timeoutObj.value && clearInterval(timeoutObj.value);
        initWebSocket();
        lockReconnect.value = false;
      }, 5000);
    };

    const startHeartbeat = () => {
      console.log("开始发送心跳");
      timeoutObj.value && clearInterval(timeoutObj.value);

      timeoutObj.value = window.setInterval(() => {
        if (websock.value.readyState == 1) {
          websocketsend(JSON.stringify("ping"));
        }
      }, 20000);
    };

    const websocketonopen = () => {
      console.log("连接成功");
      startHeartbeat();
    };
    const websocketonerror = () => {
      console.log("连接错误,正在重新连接");
      reconnect();
    };

    const websocketonmessage = (e) => {
      //数据接收
      const res = JSON.parse(e.data);
      console.log(res, "res--ooppppp");
      ElMessageBox.confirm(res.msg, "提示", {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          isShowDrawer.value = true;
          drawerId.value = res.customerId;
        })
        .catch(() => {});
    };
    const websocketsend = (Data) => {
      //数据发送
      console.log("发送消息:" + Data + "-->" + +new Date().getTime());
      websock.value.send(Data);
    };
    const websocketclose = (e) => {
      console.log("断开连接,正在重新连接", e);
      reconnect();
    };
    const showDialog = ref(true);
    const isShowDrawer = ref(false);
    const handleDrawerClose = () => (isShowDrawer.value = false);
    const drawerId = ref(null);
    const handleNameDrawer = () => {
      isShowDrawer.value = true;
      drawerId.value = 768281;
    };

    return {
      showDialog,
      isShowDrawer,
      drawerId,
      handleDrawerClose,
      handleNameDrawer,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variable.scss";
@import url("./assets/css/index.scss");
.el-button--primary {
  border-color: $blue-02 !important;
  background: $blue-02 !important;
}
</style>
